<script setup lang="ts">
useHead({
  link: [{
    rel: 'canonical',
    href: `${import.meta.env.VITE_MONOLITH_URL}/legal/referral-terms`,
  }],
})

useSeoMeta({
  title: 'Referral Partner Program: Terms and Conditions - SpotHopper',
  ogTitle: 'Referral Partner Program: Terms and Conditions - SpotHopper',
  ogImage: `${S3_ASSETS_URL}/meta-default.jpg`,
})
</script>

<template>
  <LayoutLegal>
    <h1 class="mb-5 text-[2.5rem] font-medium">
      Terms of Service
      <small class="mt-4 block">Referral program terms and conditions</small>
    </h1>

    <time datetime="05-01-2024">
      Last revised: December 23, 2025
    </time>

    <ol class="marker:text-[var(--tw-prose-bold)] [&>li]:marker:font-bold [&>li_p]:mt-1">
      <li>
        You must be a U.S. resident and at least 18 years of age to participate. Proof of identity may be required at any time during the referral process.
      </li>

      <li>
        You will be responsible for any income tax due on the referral fee. The referral process does not constitute an employee/employer relationship with SpotHopper. You are not considered an agent of SpotHopper and any statements you make about SpotHopper are not binding upon us.
      </li>

      <li>
        The contact information you provide for the referral must not be listed on the state’s do not call database.
      </li>

      <li>
        The restaurant you are referring should be open for business at the time of referral or within 30 days of their planned opening.
      </li>

      <li>
        If you are an employee of the business you are referring, you must have your employer’s consent to provide their contact information. This is due to anti-bribery laws. Proof of consent will be required.
      </li>

      <li>
        Anyone who submits two or more referrals that fail to meet the above requirements will be banned from providing further referrals.
      </li>

      <li>
        The first payment will be made only after you submit a completed W-9 and the referred party signs a contract and makes at least one payment on that contract.
      </li>

      <li>
        The second payment will be made only if the referred party completes a full year contract with us as determined by us.
      </li>

      <li>
        A valid referral is not already an existing customer of SpotHopper.
      </li>

      <li>
        By providing the referral, you are consenting to the use of your name when we contact the referral.
      </li>

      <li>
        You may not submit more than 5 referrals per day….no bulk uploads. Marketing firms are not eligible to participate in the plan.
      </li>

      <li>
        This program is void where prohibited by law.
      </li>

      <li>
        SpotHopper reserves the right to discontinue this program at anytime for any reason with or without notice.
      </li>

      <li>
        SpotHopper retains the right to deny payment in the case of fraud or ineligibility.
      </li>
    </ol>
  </LayoutLegal>
</template>
